import React from 'react';

import classes from './Alert.css';

const alert = (props) => {
    let alertElement = null;
    const inputClasses = [classes.InputElement];

    if (props.invalid && props.shouldValidate && props.touched) {
        inputClasses.push(classes.Invalid);
    }
    alertElement = 
        <div class="alert alert-danger alert-dismissible" role="alert">
        <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
            onClick={props.clicked}
        ><span aria-hidden="true">&times;</span>
        </button>
        <strong>{props.strong}</strong> {props.message}
    </div>
    return (
        <div className={classes.Input}>
            {alertElement}
        </div>
    );
};

export default alert;